import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/(public)/trouver-un-chef/")({
  beforeLoad: () => {
    throw redirect({
      to: "/trouver-un-chef/chefs",
    });
  },
  component: () => null,
});
